module.exports = __webpack_public_path__ + "static/media/news8.b04a49de.png";